import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {makeError} from "../../../components/modals/ErrorModal";
import SvGraphics from "../../../assets/SvGraphics";




class SelfDeclarationsTabComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            symptoms: [],
            entry: this.props.entry,

        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }


    async showNotification(code, value) {
        let {t}=this.props
        let {entry}=this.state
        this.props.onYesNoValueChange(code, value)
        if(entry[code]==="Yes"){
            let message= code==="Medical_institute_road_safety"?t('patient_boarding.Notify_medical_institute'):t('patient_boarding.Notify_ministry_affairs')
            await makeError({
                proceedLabel: t('patient_boarding.ok'),
            }, [message]);
        }
    }
    render() {

        let {entry} = this.state
        let {t}=this.props

        return (


            <div className={'patientForm-box-container'}>
                <div className={'patientsFormBoxes-title-text'}>
                    <label className={'patientsFormBoxes-title-text-label'}>
                        {t('patient_boarding.declarations')}
                    </label>
                </div>

                    <div className={'patientsFormBoxes'}>


                        <div className={'patientsFormRow-declarations'}>
                            <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                            <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration_side_effects')}</label>
                        </div>
                        <div className={'patientsFormRow-declarations'}>
                            <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                            <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration_legally')}</label>
                        </div>
                        <div className={'patientsFormRow-declarations'}>
                            <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                            <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration_received_instructions')}</label>
                        </div>
                        <div className={'patientsFormRow-declarations'}>
                            <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                            <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration_identify')}</label>
                        </div>
                        <div className={'patientsFormRow-declarations'}>
                            <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                            <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration_examination_performed')}</label>
                        </div>
                        <div className={'patientsFormRow-declarations'}>
                            <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                            <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration_area_of_expertise')}</label>
                        </div>
                        <div className={'patientsFormRow-declarations'}>
                            <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                            <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration_follow_up')}</label>
                        </div>
                        <div className={'patientsFormRow-declarations'}>
                            <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                            <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration_medical_consent')}</label>
                        </div>
                        <div className={'patientsFormRow-declarations'}>
                            <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                            <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration_specified_use')}</label>
                        </div>
                        <div className={'patientsFormRow-declarations'}>
                            <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                            <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration_correct_details')}</label>
                        </div>

                        <div className={'blankSpace'}/>

                        <div className={'checkbox-label'}>
                            <input type={"checkbox"} className={"checkboxStyle"} name={'DeclarationAccept'} checked={entry.DeclarationAccept}
                                   onChange={event => this.props.onClickCheckboxes(event.target.name)}/>
                            <label className={'infoLabel'} style={{color:'#000000'}}>{t('patient_boarding.DeclarationAcceptDoctor')}</label>
                        </div>




                        {/*     <div className={'patientsFormRow-declarations'}>
                                <label className={'infoLabel'}>{t('patient_boarding.Declaration_regarding_system')}</label>
                        </div>*/}
                  {/*      <div className={"line-between"}/>

                        <div className={'patientsFormRow-declarations'}>
                            <div className={'inputSlotsFlex'}>
                                <label className={'infoLabel-med'}>{t('patient_boarding.Declaration_study_participation')}?</label>
                                <button tabIndex={0}  className={entry.Declaration_study_participation==="Yes"? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                        onClick={(event) => this.props.onYesNoValueChange("Declaration_study_participation","Yes")}>{t('patient_boarding.yes')}</button>
                                <button tabIndex={0}  className={entry.Declaration_study_participation==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                        onClick={(event) => this.props.onYesNoValueChange("Declaration_study_participation","No")}>{t('patient_boarding.no')}</button>
                                <div className={'inputBoxStyle-yes-no-empty'}/>
                            </div>
                        </div>

                        <div className={'patientsFormRow-declarations'}>
                            <div className={'inputSlotsFlex'}>
                                <label className={'infoLabel-med'}>{t('patient_boarding.Declaration_received_instructions')}?</label>
                                <button tabIndex={0}  className={entry.Declaration_received_instructions==="Yes"? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                        onClick={(event) => this.props.onYesNoValueChange("Declaration_received_instructions","Yes")}>{t('patient_boarding.yes')}</button>
                                <button tabIndex={0}  className={entry.Declaration_received_instructions==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                        onClick={(event) => this.props.onYesNoValueChange("Declaration_received_instructions","No")}>{t('patient_boarding.no')}</button>
                                <div className={'inputBoxStyle-yes-no-empty'}/>
                            </div>
                        </div>

                        <div className={"line-between"}/>

                        <div className={'patientsFormRow-declarations'}>
                            <div className={'inputSlotsFlex'}>
                                <label className={'infoLabel-med'}>{t('patient_boarding.Medical_institute_road_safety')}</label>
                                <button tabIndex={0}  className={entry.Medical_institute_road_safety==="Yes"? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                        onClick={(event) => this.showNotification("Medical_institute_road_safety","Yes")}>{t('patient_boarding.yes')}</button>
                                <button tabIndex={0}  className={entry.Medical_institute_road_safety==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                        onClick={(event) => this.showNotification("Medical_institute_road_safety","No")}>{t('patient_boarding.no')}</button>
                                <div className={'inputBoxStyle-yes-no-empty'}/>
                            </div>
                        </div>*/}


                    {/*    <div className={'patientsFormRow-declarations'}>
                            <div className={'inputSlotsFlex'}>
                                <label className={'infoLabel-med'}>{t('patient_boarding.Ministry_Interior_matters')}</label>
                                <button tabIndex={0}  className={entry.Ministry_Interior_matters==="Yes"? 'inputBoxStyle-yes-no-selected' :'inputBoxStyle-yes-no'}
                                        onClick={(event) => this.showNotification("Ministry_Interior_matters","Yes")}>{t('patient_boarding.yes')}</button>
                                <button tabIndex={0}  className={entry.Ministry_Interior_matters==="No"? 'inputBoxStyle-yes-no-selected' :'inputBoxStyle-yes-no'}
                                        onClick={(event) => this.showNotification("Ministry_Interior_matters","No")}>{t('patient_boarding.no')}</button>
                                <div className={'inputBoxStyle-yes-no-empty'}/>
                            </div>
                        </div>*/}


                    </div>
            </div>
        );
    }
}



const SelfDeclarationsTab = compose(
    withTranslation(),
    /*connect(
        mapStateToProps,
        mapDispatchToProps
    )*/
)(SelfDeclarationsTabComposed);

export default SelfDeclarationsTab;

